import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8669cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manga-setting-index" }
const _hoisted_2 = { class: "manga-setting-box" }
const _hoisted_3 = { id: "payload" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("表格"),
      _createVNode(_component_el_table, {
        data: $setup.tableData,
        stripe: "",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: $setup.t('account.serial'),
            width: "54"
          }, null, 8 /* PROPS */, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: $setup.t('jobsManage.id'),
            width: "100"
          }, null, 8 /* PROPS */, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "queue",
            label: $setup.t('jobsManage.queue'),
            width: "86"
          }, null, 8 /* PROPS */, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: $setup.t('createTime'),
            width: "160"
          }, null, 8 /* PROPS */, ["label"]),
          _createVNode(_component_el_table_column, {
            label: $setup.t('account.option')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                icon: $setup.Edit,
                onClick: ($event: any) => ($setup.edit_manga(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('option.check')), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["icon", "onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                icon: $setup.Delete,
                onClick: ($event: any) => ($setup.delete_manga(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('option.delete')), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["icon", "onClick"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data"]),
      _createCommentVNode("分页"),
      _createVNode($setup["tablePager"], {
        ref: "pager",
        onPageChange: $setup.load_table,
        count: $setup.count
      }, null, 8 /* PROPS */, ["count"]),
      _createVNode(_component_el_dialog, {
        title: $setup.t('jobsManage.details'),
        modelValue: $setup.editMangaDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.editMangaDialog) = $event)),
        "before-close": $setup.dialog_close
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode("按钮盒子"),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: $setup.copy_payload,
                id: "copy-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('option.copy')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.editMangaDialog = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('option.cancel')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("pre", _hoisted_3, [
            _createElementVNode("code", null, _toDisplayString($setup.payload), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "modelValue"])
    ])
  ]))
}